import {Component} from '@angular/core';
import {LogUpdateService} from './_services/log-update.service';
import { LogingService } from './_services/loging.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'login';

    constructor(private updateService: LogUpdateService, private loging: LogingService) {
        /*const appIsStable$ = appRef.isStable.pipe(first(isStable => isStable === true));
            const everySixHours$ = interval(9 * 90 * 90);
        const everySixHoursOnceAppIsStable$ = concat(appIsStable$, everySixHours$);

    /*const appIsStable$ = appRef.isStable.pipe(first(isStable => isStable === true));
        const everySixHours$ = interval(9 * 90 * 90);
    const everySixHoursOnceAppIsStable$ = concat(appIsStable$, everySixHours$);

    everySixHoursOnceAppIsStable$.subscribe(() => updates.checkForUpdate());*/
    this.updateService.checkForUpdates();
  }
}
